// ********************************************************
//
// IMPORT
//
// ********************************************************
import VConsole from 'vconsole'

//import WechatService from '@/services/WechatService'
// import WechatShareService from '@/services/WechatShareService'
// import VideoService from '@/services/VideoService'
// import FontService from '@/services/FontService'
// import AssetService from '@/services/AssetService'
// import SoundService from '@/services/SoundService'
//import GameService from '@/services/GameService'
import '@/services/ResizeService'
//import '@/services/AnalyticsService'
import '@/helpers/Raf'

// import fontManifest from '@/config/fonts'
// import assetManifest from '@/config/asset'
// import mediaManifest from '@/config/media'
// import soundManifest from '@/config/sound'

import store from '@/store'

// ********************************************************
//
// DOCUMENT
//
// ********************************************************
const loadDocument = function() {
  return new Promise((resolve) => {
    const onReady = function() {
      resolve()
    }

    if (document.readyState === 'complete') {
      onReady()
    } else {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          onReady()
        }
      }
    }
  })
}

// ********************************************************
//
// APP
//
// ********************************************************
async function initApp() {
  await loadDocument()

  console.group('Initialization')

  store.commit('app/setLoadStep', 'vconsole')
  if (store.state.app.vconsole) new VConsole()

  //store.commit('app/setLoadStep', 'wechat')
  //await WechatShareService.init()

  store.commit('app/setLoadStep', 'app')
  await import('./main')

  // store.commit('app/setLoadStep', 'fonts')
  // await FontService.load(fontManifest)

  // store.commit('app/setLoadStep', 'sound')
  // await SoundService.load(soundManifest)

  // store.commit('app/setLoadStep', 'assets')
  // await AssetService.load(assetManifest)
  //store.commit('app/setLoadStep', 'game')
  //await GameService.load()

  store.commit('app/setLoadStep', 'completed')
  //store.commit('app/setLoadComplete')

  console.groupEnd()

  //store.dispatch('app/getVersion')
}

// ********************************************************
//
// INIT
//
// ********************************************************
//initApp()
if (store.state.browser.isMobile) {
  initApp()
} else {
  import('./desktop')
}


window.store = store
